import React from 'react'
import { useParams } from 'react-router'
import { useNavigate } from 'react-router-dom'

import arrow from '@/assets/health/health_arrow_img.png'
import { COLOR } from '@/shared/constant/color'
import { HealthContents } from '@/shared/constant/text'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import { CustomBtn } from '@/styles/common/CommonForm/buttonform'
import { HealthContent, HealthTitle, HealthWrap } from '@/styles/views/Letter/health'

const HealthExamplePage = () => {
  const params = useParams().idx
  const navigate = useNavigate()
  const { width } = useWindowDimensions()

  const FindItem = (element: any) => {
    return element.path === params
  }

  const HealthItem: any = HealthContents?.find(FindItem)

  return (
    <HealthWrap>
      <HealthTitle className={'health'}>{HealthItem?.title}</HealthTitle>
      <HealthContent>
        <img src={HealthItem?.imgSrc} alt="" />
        <p dangerouslySetInnerHTML={{ __html: HealthItem?.desc }} />
      </HealthContent>
      <CustomBtn
        className={width > 1200 ? 'health_btn_pc' : 'health_btn_mo'}
        color={COLOR.point1}
        bgColor={COLOR.white}
        borderRadius={'40px'}
        borderColor={COLOR.point1}
        marginTop={width > 1200 ? '47px' : '50px'}
        width={width > 1200 ? '356px' : '328px'}
        height={width > 1200 ? '56px' : '44px'}
        fontSize={width > 1200 ? '18px' : '14px'}
        fontFamily={width > 1200 ? 'NanumSquareNeoHeavy, sans-serif' : 'NotoSansBold, sans-serif'}
        onClick={() => navigate(-1)}
      >
        <img src={arrow} alt="" />
        <span>이전으로</span>
      </CustomBtn>
    </HealthWrap>
  )
}

export default HealthExamplePage
